import { HttpEventType, HttpResponse } from "@angular/common/http";
import {
  ChangeDetectorRef,
  AfterContentChecked,
  Component,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from "@angular/forms";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FileItem, FileUploader } from "ng2-file-upload";
import {
  Subscription,
  Observable,
  Subject,
  lastValueFrom,
  startWith,
  map,
  filter,
  takeUntil,
  pairwise,
} from "rxjs";
import { AppParams, JobDynamicProp } from "src/app/core/models/appParams";
import {
  CloudTypes,
  FileTypes,
  HpcVMStates,
  JobTypes,
  PlatformTypes,
} from "src/app/core/models/globals";
import {
  Job,
  JobPriorityText,
  JobPriorityVal,
  JobTemplate,
  JobUploadFieldType,
} from "src/app/core/models/job";
import {
  JsonFormControls,
  JsonFormData,
} from "src/app/core/models/jobJsonForm";
import { Node } from "src/app/core/models/node";
import {
  AzureStorageType,
  AzureTransferProgress,
} from "src/app/core/models/storage";
import { StorageDataType } from "src/app/core/models/storage-data-type";
import { ApplicationService } from "src/app/core/services/application.service";
import { AuthenticationService } from "src/app/core/services/authentication.service";
import { JobsService } from "src/app/core/services/jobs.service";
import { NodeService } from "src/app/core/services/node.service";
import { StorageDataTransferService } from "src/app/core/services/storage-data-transfer.service";
import { StorageService } from "src/app/core/services/storage.service";
import { UserService } from "../../../../../core/services/user.service";
import { StoreExplorerComponent } from "../../jobActions/store-explorer/store-explorer.component";
import {
  UserDetails,
  UserJobPathData,
  UserRolesInt,
  Users,
} from "src/app/core/models/users";
import { ManageZipDialogComponent } from "../../jobActions/manage-zip-dialog/manage-zip-dialog.component";
import { EnvironmentService } from "../../../../../core/services/environment.service";
import { FileEditorComponent } from "../../jobActions/file-editor/file-editor.component";
import { NgxSpinnerService } from "ngx-spinner";
import { StorageOracleService } from "src/app/core/services/storage-oracle.service";
import { HeaderService } from "src/app/core/services/header.service";
import { GoogleCloudService } from "../../../../../core/services/google-cloud.service";
import { DeploymentService } from "src/app/core/services/deployment.service";
import { ConfigEntityService } from "src/app/core/services/config-entity.service";
import { ActionLogService } from "src/app/core/services/action-log.service";
import { FileAlreadyExistsActionComponent } from "src/app/modules/storage/modals/file-already-exists-action/file-already-exists-action.component";
import {
  Application,
  ApplicationVersion,
} from "src/app/core/models/application";
import { DatePipe } from "@angular/common";
import { JobTemplateService } from "src/app/core/services/job-template.service";
import { ConfirmationDialogComponent } from "src/app/modules/shared/components/confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: "app-aiml-job",
  templateUrl: "./aiml-job.component.html",
  styleUrls: ["./aiml-job.component.scss"],
})
export class AimlJobComponent implements OnInit, AfterContentChecked {
  @ViewChild("dt1") dt1: any;

  constructor(
    public dialogRef: MatDialogRef<AimlJobComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      cloudType: string;
      depName: string;
      appName: string;
      nodeName: string;
      jobName: string;
      isResubmit: boolean;
      suggestions: [];
      headNodeIp: string;
      alreadyAllocatedCores: number;
      copyJobDataToSyncstore: string;
      keepJobDataInWorkstore: string;
      isJobUpdatedFlag: boolean;
      templateName: string;
      routeViaSynchpc: boolean;
      tags: string | null;
    },
    public jobService: JobsService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private applicationService: ApplicationService,
    private authenticationService: AuthenticationService,
    private storageService: StorageService,
    public storageDataTransferService: StorageDataTransferService,
    private snackBar: MatSnackBar,
    private nodeService: NodeService,
    private datePipe: DatePipe,
    private userService: UserService,
    private cd: ChangeDetectorRef,
    private env: EnvironmentService,
    private _oracleService: StorageOracleService,
    private _headerService: HeaderService,
    private googleCloudService: GoogleCloudService,
    private deploymentService: DeploymentService,
    private configEntityService: ConfigEntityService,
    private actionLogService: ActionLogService,
    private jobTemplateService: JobTemplateService,
    private myElement: ElementRef
  ) {}

  StdOutPattern: string = "^[a-zA-Z0-9_%+-]+(\.[a-zA-Z0-9]+)?$";
  jobTag;
  aimlJobForm: UntypedFormGroup;
  depName: string = this.data.depName;
  appName: string = this.data.appName;
  isHeadnodeActive: boolean = true;
  aimlUploadSub: Subscription;
  priorities: string[] = [];
  groups: string[] = [];
  jobDetails: Job;
  cancelledFiles = {}; // contains subject of active uploads
  jobAdditionalInputFiles: StorageDataType[] = []; // contains list of inputfiles
  filesToCopy: string[] = []; // contains list of files which are to be copied
  selectedFiles: FileList; // contains list of files which are selected
  splitFiles = [];
  useFixedNoOfCores: boolean = false;
  staticCores: number[] = [];
  isUploadActive: boolean = false; // to check if upload is active
  minimumCores: number;
  maximumCores: number;
  suggestions: [] = this.data.suggestions;
  tagSuggestions: [] = [];
  filteredTagOptions: Observable<string[]>;
  filteredOptions: Observable<string[]>;
  maximumCoresAllowed: number = 0;
  cloudType: string = this.data.cloudType;
  uniqueAzureProgressId: number = 0;
  azureTransferSub: Subscription;
  currentLoggedInUser = this.authenticationService.currentUserValue.username;
  headNodeIpForUpload: string = this.data.headNodeIp;
  todayDate = new Date().toISOString().substring(0, 16);
  users: Users;
  profileId: string = "";
  loggedInUser: string = this.authenticationService.currentUserValue.username;
  userInfoesData: UserDetails[];
  userDetails: Users;
  userRole: number;
  defaultStdOutFileName: string;
  defaultStdErrFileName: string;
  uploader: FileUploader = new FileUploader({
    url: this.deploymentService.getUrlForUtilityService(
      this.depName,
      this.data.headNodeIp,
      this.env.envVariables.UtilityAccessPort,
      1,
      this.data.routeViaSynchpc
    ),
    headers: [
      {
        name: "destinationpath",
        value: `${this.env.envVariables.syncStoreRoute}/${this.currentLoggedInUser}`,
      },
      { name: "requestUser", value: this.currentLoggedInUser },
    ],
    method: "post",
  });
  currentStorageName: string = this._headerService.getStorageNameForDeployment(
    this.depName
  );
  makeJobTagMandatoryFlag: boolean = this.env.envVariables.makeJobTagMandatory;
  customTagName: string = this.env.envVariables.customTagName;
  customTagValues: string[] = this.env.envVariables.customTagValues?.split(",");
  minDate = new Date(
    new Date().getTime() + (330 + new Date().getTimezoneOffset()) * 60000
  );
  maxDate = new Date(
    new Date().getTime() + (330 + new Date().getTimezoneOffset()) * 60000
  );
  submitJobWithoutHN: boolean =
    this.configEntityService.SyncHpcXMLParameters?.find(
      (x) => x.parameterName == "SubmitJobWithoutHN"
    )?.parameterValue == "true" || false;
  jobOutDir = `${this.env.envVariables.syncStoreRoute}/${this.currentLoggedInUser}/`;
  jobJson: JsonFormData;
  outDirMessage: string = this.env.envVariables.copyOutputToInputFileDirectory
    ? "Output directory will be same as input file directory"
    : this.jobOutDir;
  autoSubmitAfterUpload: boolean = false;
  userJobPathData: UserJobPathData;
  jobInputIds = {
    aiml_scriptFile: null,
  };
  jobInputFiles: JobUploadFieldType[] = []; // contains list of inputfiles
  aiml_environments = [
    "amancevice/pandas:1.3.0-slim",
    "jupyter/tensorflow-notebook",
    "pytorch/pytorch",
    "tensorflow/tensorflow",
    "smizy/scikit-learn",
    "fluiddyn/python3-stable",
    "czentye/matplotlib-minimal",
    "huanjason/scikit-learn",
    "jermine/opencv:latest",
  ];
  jobTemplateNameValue: string = this.data.templateName
    ? this.data.templateName
    : "";
  isTemplateNameBeingEdited = false;
  versions: ApplicationVersion[] = [];

  reg: string = this.env.envVariables.fileUploadRegex;
  regexObj: any = new RegExp(this.reg);
  FileTypes = FileTypes;

  @ViewChild("workStoreSelect_aiml_inputScriptFile")
  workStoreSelect_aiml_inputScriptFile;

  public formData: JsonFormData;

  onFileChange(inputName) {
    switch (inputName) {
      case "workStoreSelect_aiml_inputScriptFile":
        this.workStoreSelect_aiml_inputScriptFile.nativeElement.value = "";
    }
  }

  checkMaxCores() {
    if (this.minimumCores == undefined) {
      this.minimumCores = this.maximumCores;
    }
    if (this.minimumCores > this.maximumCores) {
      this.aimlJobForm.controls["aiml_numberOfCoresMin"].setErrors({
        invalidCore: true,
      });
    } else {
      this.aimlJobForm.controls["aiml_numberOfCoresMin"].setErrors(null);
    }
    this.minimumCores = this.maximumCores;
  }

  getUserJobPathData(loggedUser, depName) {
    this.userService.getUserJobDirectoryPath(loggedUser, depName).subscribe({
      next: (data) => {
        this.userJobPathData = <UserJobPathData>(
          JSON.parse(JSON.stringify(data))
        );
        if (this.userJobPathData.deploymentData.jobValue == 3) {
          this.aimlJobForm.get("customWorkDirectoryPath").enable();
        }
      },
      error: (err) => {},
    });
  }

  checkMinCores() {
    if (this.maximumCores == undefined) {
      this.maximumCores = this.minimumCores;
    }
    if (this.minimumCores > this.maximumCores) {
      this.aimlJobForm.controls["aiml_numberOfCoresMin"].setErrors({
        invalidCore: true,
      });
    }
  }

  ngOnInit() {
    if (this.jobTemplateNameValue) {
      this.isTemplateNameBeingEdited = true;
    }
    this.userService.getUserRole(this.loggedInUser).subscribe((data) => {
      this.userRole = Number(data);
      if (!this.data.isResubmit) {
        this.getSetAppVersionNodeGroup();
      }
    });
    this.createaimlJobForm();
    this.getTags();
    this.checkNodeData();
    this.arrangeJobNameSuggestions();
    this.updatePriority();
    if (this.env.envVariables.fixedNoOfCores) {
      this.assignFixedCores();
    }
    this.autoFillAIMLResubmitForm();
    if (this.cloudType == CloudTypes.OnPremise) {
      this.configureNg2FileUpload();
    } else if (this.cloudType == CloudTypes.MicrosoftAzure) {
      this.checkAzureUpload();
    }
  }

  getTags() {
    this.jobService
      .getApplicationTags(this.depName, this.appName)
      .subscribe((data: any) => {
        this.jobTag = data["tags"];
        this.tagSuggestions = data["tags"];
        this.defaultStdOutFileName = data["defaultStdOutFileName"];
        this.defaultStdErrFileName = data["defaultStdErrFileName"];
        this.arrangeTagSuggestions();
        if (this.aimlJobForm && this.aimlJobForm.controls["aiml_standardOutputFile"]) {
          this.aimlJobForm.controls["aiml_standardOutputFile"].setValue(this.defaultStdOutFileName);
        }
      });
  }

  createaimlJobForm() {
    this.aimlJobForm = new UntypedFormGroup({
      aiml_jobNamePrefix: new UntypedFormControl(
        "",
        Validators.pattern('^[a-z0-9]([-a-z0-9]*[a-z0-9])?$'),
      ),
      aiml_standardOutputFile: new UntypedFormControl(
        this.defaultStdOutFileName,
        Validators.pattern(this.StdOutPattern)
      ),
      aiml_numberOfCoresMax: new UntypedFormControl(null, [
        Validators.required,
        Validators.min(1),
      ]),
      aiml_numberOfCoresMin: new UntypedFormControl(null, [
        Validators.required,
        Validators.min(1),
      ]),
      aiml_Priority: new UntypedFormControl(Validators.required),

      dependecy: new UntypedFormControl(null),
      jobID: new UntypedFormControl({ value: null, disabled: true }),
      aiml_startCommand: new UntypedFormControl(""),
      aiml_NodeGroup: new UntypedFormControl(null, Validators.required),
      aiml_Tag: new UntypedFormControl(this.data.tags),
      //aiml_jobCommand: new UntypedFormControl(null, Validators.required),
      aiml_BackupData: new UntypedFormControl({
        value: this.data.copyJobDataToSyncstore,
        disabled: this.authenticationService.isUserGlobalAdmin ? false : true,
      }),
      aiml_keepWorkStoreData: new UntypedFormControl({
        value: this.data.keepJobDataInWorkstore,
        disabled: this.authenticationService.isUserGlobalAdmin ? false : true,
      }),
      aiml_endCommand: new UntypedFormControl(""),
      aiml_autoShut: new UntypedFormControl(false),
      aiml_jobSchedule: new UntypedFormControl(false),
      aiml_customDate: new UntypedFormControl(null),
      aiml_customTag: new UntypedFormControl(null),
      aiml_memoryPerCpu: new UntypedFormControl(null, [
        Validators.pattern("^[0-9]*$"),
      ]),
      aiml_wallclockTime: new UntypedFormControl(null, [
        Validators.pattern("^[0-9]*$"),
      ]),
      aiml_MinScratchSpace: new UntypedFormControl(4, [
        Validators.pattern("^[0-9]*$"),
      ]),
      aiml_ScheduleTime: new UntypedFormControl(null),
      aiml_taskPerNode: new UntypedFormControl(0, [
        Validators.pattern("^[0-9]*$"),
      ]),
      aiml_isExclusive: new UntypedFormControl("1"),
      aiml_outputDirectory: new UntypedFormControl(null),
      customWorkDirectoryPath: new UntypedFormControl({
        value: null,
        disabled: true,
      }),
      aiml_NumOfGpuForJob: new UntypedFormControl(0, [
        Validators.min(0),
        Validators.pattern(/^[0-9]+$/), 
        Validators.required
      ]),
      aiml_NumOfGpuPerTask: new UntypedFormControl(0),
      aiml_scriptFile: new UntypedFormControl(null, Validators.required),
      aiml_numberOfCompletions: new UntypedFormControl(1, [
        Validators.pattern("^[0-9]*$"),
      ]),
      aiml_backOffLimit: new UntypedFormControl(5, [
        Validators.pattern("^[0-9]*$"),
      ]),
      aiml_environment: new UntypedFormControl(null),
      aiml_versionControl: new UntypedFormControl("", Validators.required),
    });

    this.aimlJobForm.controls["aiml_environment"].setValue([
      this.aiml_environments[0],
    ]);

    this.aimlJobForm.get("dependecy").valueChanges.subscribe((value) => {
      if (!value || value != "None") {
        this.aimlJobForm.get("jobID").enable();
        this.aimlJobForm.controls["jobID"].setValidators(Validators.required);
        this.aimlJobForm.controls["jobID"].updateValueAndValidity();
      } else {
        this.aimlJobForm.get("jobID").disable();
        this.aimlJobForm.controls["jobID"].setValidators(null);
        this.aimlJobForm.controls["jobID"].updateValueAndValidity();
      }
    });
    this.maxDate.setDate(this.minDate.getDate() + 7);
    this.aimlJobForm.controls["aiml_customDate"].disable();
    if (this.makeJobTagMandatoryFlag) {
      this.aimlJobForm.controls["aiml_Tag"].setValidators(Validators.required);
    }
    if (this.customTagName) {
      this.aimlJobForm.controls["aiml_customTag"].setValidators(
        Validators.required
      );
    }
    this.aimlJobForm.controls["aiml_jobSchedule"].valueChanges.subscribe(
      (val) => {
        if (val) {
          this.aimlJobForm.controls["aiml_customDate"].setValue(this.todayDate);
          this.aimlJobForm.controls["aiml_customDate"].enable();
          return;
        }
        this.aimlJobForm.controls["aiml_customDate"].setValue(null);
        this.aimlJobForm.controls["aiml_customDate"].disable();
      }
    );
    this.aimlJobForm.controls["aiml_versionControl"].valueChanges
      .pipe(startWith(null as string), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.getApplicationStaticCores(next?.value);
        this.loadJobForm(next?.value);
      });
  }

  ngAfterContentChecked() {
    this.cd.detectChanges();
  }

  autoFillAIMLResubmitForm() {
    if (this.data.isResubmit) {
      this.spinner.show("resubmitJob");
      this.jobService
        .getJobDetailsForUser(
          this.depName,
          this.data.jobName,
          this.data.templateName,
          this.data.appName
        )
        .subscribe((data) => {
          this.snackBar.dismiss();
          if (data) {
            this.jobDetails = <Job>JSON.parse(JSON.stringify(data));
            this.getSetAppVersionNodeGroup();
            let autoFillData: AppParams = JSON.parse(
              this.jobDetails.appPropJson
            );
            this.aimlJobForm.controls["aiml_standardOutputFile"].setValue(
              autoFillData.JobGenericProperties.StdOutFile
            );

            this.aimlJobForm.controls["aiml_NumOfGpuForJob"].setValue(
              autoFillData.JobGenericProperties.NumOfGpuForJob
            );

            this.aimlJobForm.controls["aiml_NumOfGpuPerTask"].setValue(
              autoFillData.JobGenericProperties.NumOfGpuPerTask
            );

            this.aimlJobForm.controls["customWorkDirectoryPath"].setValue(
              autoFillData.JobGenericProperties.CustomWorkDirectoryPath
            );
            this.setMinMaxCores(
              autoFillData.JobGenericProperties.ActualCores,
              autoFillData.JobGenericProperties.MinCores
            );
            this.aimlJobForm.controls["aiml_startCommand"].setValue(
              autoFillData.JobGenericProperties.StartCommand
            );
            this.aimlJobForm.controls["aiml_NodeGroup"].setValue(
              autoFillData.JobGenericProperties.NodeGroup == ""
                ? ["Default"]
                : autoFillData.JobGenericProperties.NodeGroup.split(",")
            );
            this.aimlJobForm.controls["aiml_Priority"].setValue(
              autoFillData.JobGenericProperties.JobPriority
            );
            this.aimlJobForm.controls["aiml_scriptFile"].setValue(
              autoFillData.AIMLProperties.ScriptFile
            );
            if (autoFillData.AIMLProperties.ScriptFile != null) {
              this.filesToCopy.push(autoFillData.AIMLProperties.ScriptFile);
            }
            this.setAdditionalInputFiles(
              autoFillData.JobGenericProperties.FilesToCopy || ""
            );
            this.aimlJobForm.controls["aiml_BackupData"].setValue(
              autoFillData.JobGenericProperties.ToBackupData
            );
            this.aimlJobForm.controls["aiml_keepWorkStoreData"].setValue(
              autoFillData.JobGenericProperties.KeepWorkStoreData
            );
            this.updateJobName(
              autoFillData.JobGenericProperties.JobName,
              this.jobDetails.number
            );
            this.aimlJobForm.controls["aiml_endCommand"].setValue(
              autoFillData.JobGenericProperties.EndCommand
            );
            this.aimlJobForm.controls["aiml_autoShut"].setValue(
              autoFillData.JobGenericProperties.IsAutoShut
            );
            this.aimlJobForm.controls["aiml_customDate"].setValue(
              autoFillData.JobGenericProperties.CreateTime
            );
            this.aimlJobForm.controls["aiml_memoryPerCpu"].setValue(
              autoFillData.JobGenericProperties.MemoryPerCpu
            );
            this.aimlJobForm.controls["aiml_wallclockTime"].setValue(
              autoFillData.JobGenericProperties.WallclockTime
            );
            this.aimlJobForm.controls["aiml_MinScratchSpace"].setValue(
              autoFillData.JobGenericProperties.MinScratchSpace
            );
            this.aimlJobForm.controls["aiml_taskPerNode"].setValue(
              autoFillData.JobGenericProperties.TasksPerNode
            );
            this.aimlJobForm.controls["aiml_isExclusive"].setValue(
              autoFillData.JobGenericProperties.ExclusiveJob.toString()
            );
            this.aimlJobForm.controls["aiml_environment"].setValue(
              autoFillData.AIMLProperties.ProcessDataImage?.toString()
            );
            this.aimlJobForm.controls["aiml_numberOfCompletions"].setValue(
              autoFillData.AIMLProperties.Completions
            );
            this.aimlJobForm.controls["aiml_backOffLimit"].setValue(
              autoFillData.AIMLProperties.BackOffLimit
            );
          }
        });
    }
    this.spinner.hide("resubmitJob");
  }

  createForm(controls: JsonFormControls[]) {
    for (const control of controls) {
      const validatorsToAdd = [];
      if (control.Validators) {
        for (const [key, value] of Object.entries(control.Validators)) {
          switch (key.toLowerCase()) {
            case "min":
              validatorsToAdd.push(Validators.min(value));
              break;
            case "max":
              validatorsToAdd.push(Validators.max(value));
              break;
            case "required":
              if (value) {
                validatorsToAdd.push(Validators.required);
              }
              break;
            case "requiredTrue":
              if (value) {
                validatorsToAdd.push(Validators.requiredTrue);
              }
              break;
            case "email":
              if (value) {
                validatorsToAdd.push(Validators.email);
              }
              break;
            case "minLength":
              validatorsToAdd.push(Validators.minLength(value));
              break;
            case "maxLength":
              validatorsToAdd.push(Validators.maxLength(value));
              break;
            case "pattern":
              validatorsToAdd.push(Validators.pattern(value));
              break;
            case "nullValidator":
              if (value) {
                validatorsToAdd.push(Validators.nullValidator);
              }
              break;
            default:
              break;
          }
        }
      }
      if (control.Type == "inputFile") {
        this.jobInputIds[control.Name] = null;
      }
      if (
        (control.Type == "checkbox" && control.Value == "true") ||
        control.Value == "false"
      ) {
        control.Value = JSON.parse(control.Value);
      }
      if (!control.Name.includes("dynamic_"))
        control.Name = `dynamic_${control.Name}`;
      this.aimlJobForm.addControl(
        control.Name,
        new UntypedFormControl(control.Value, validatorsToAdd)
      );
    }
    if (this.data.isResubmit) {
      let autoFillData: AppParams = JSON.parse(this.jobDetails.appPropJson);
      if (autoFillData.DynamicAppProperties) {
        Object.entries(autoFillData.DynamicAppProperties).forEach(
          ([key, value], index) => {
            let idx = this.jobJson.Controls.findIndex(
              (c) => c.Name == `dynamic_${value.dynamicAppKey}`
            );
            let controlVal =
              this.jobJson.Controls[idx].Type == "checkbox"
                ? Boolean(JSON.parse(value.dynamicAppValue))
                : value.dynamicAppValue;
            this.aimlJobForm.controls[
              `dynamic_${value.dynamicAppKey}`
            ].setValue(controlVal);
            if (this.jobJson.Controls[idx].Type == "inputFile") {
              this.filesToCopy.push(value.dynamicAppValue);
            }
          }
        );
      }
      this.setAdditionalInputFiles(
        autoFillData.JobGenericProperties.FilesToCopy
      );
    }
  }

  removeDynamicFormFields() {
    if (!this.jobJson) return;
    this.jobJson.Controls.forEach((control) => {
      if (control.Name.includes("dynamic_")) {
        this.aimlJobForm.removeControl(control.Name);
      }
    });
  }

  loadJobForm(version: string) {
    if (!version) return;
    this.removeDynamicFormFields();
    this.applicationService
      .getJobJson(this.depName, this.appName, version)
      .subscribe({
        next: (data: JsonFormData) => {
          if (!data) {
            this.jobJson = null;
            this.formData = null;
            return;
          }
          const jsonData = Object.assign({}, data);
          this.jobJson = jsonData;
          this.createForm(data.Controls);
          this.formData = data;
        },
        error: (err) => {},
      });
  }

  updatePriority() {
    let priorityVal;

    this.userService
      .getJobPriority(this.currentLoggedInUser, this.depName)
      .subscribe({
        next: (data: any) => {
          if (data != null) {
            priorityVal = data.jobPro;
            for (let i = priorityVal; i <= 4; i++) {
              if (i === JobPriorityVal.Normal) {
                this.priorities.push(JobPriorityText.Normal);
              }
              if (i === JobPriorityVal.AboveNormal) {
                this.priorities.push(JobPriorityText.AboveNormal);
              }
              if (i === JobPriorityVal.BelowNormal) {
                this.priorities.push(JobPriorityText.BelowNormal);
              }
              if (i === JobPriorityVal.Highest) {
                this.priorities.push(JobPriorityText.Highest);
              }
              if (i === JobPriorityVal.Lowest) {
                this.priorities.push(JobPriorityText.Lowest);
              }
            }
            if (priorityVal <= JobPriorityVal.Normal) {
              this.aimlJobForm.controls["aiml_Priority"].setValue(
                JobPriorityText.Normal
              );
            } else {
              this.aimlJobForm.controls["aiml_Priority"].setValue(
                this.priorities[0]
              );
            }
          } else {
            this.priorities.push(JobPriorityText.Normal);
            this.aimlJobForm.controls["aiml_Priority"].setValue(
              this.priorities[0]
            );
          }
        },
        error: (err) => {
          this.priorities.push(JobPriorityText.Normal);
          this.aimlJobForm.controls["aiml_Priority"].setValue(
            this.priorities[0]
          );
        },
      });
  }

  getApplicationStaticCores(appVer) {
    if (!appVer) return;
    this.groups = [];
    this.applicationService
      .getApplicationStaticCores(
        this.depName,
        JobTypes.AIML,
        appVer,
        this.currentLoggedInUser
      )
      .subscribe({
        next: (data: any) => {
          const parseNumberArray = (input: string): number[] =>
            input ? input.split(",").map((x) => +x) : [];

          const { cores, appNodeGroup, memoryPerCpu, defaultNodeGroups } = data;

          let previousCores = this.aimlJobForm.value?.aiml_numberOfCoresMax;

          // Cores optimization
          this.useFixedNoOfCores = false;
          let coresArray: number[] = parseNumberArray(
            cores || this.env.envVariables.fixedNoOfCores
          );
          if (coresArray.length > 0) {
            this.assignFixedCores(coresArray);
          } else if (!this.data.isResubmit) {
            if (previousCores) {
              this.aimlJobForm.controls["aiml_numberOfCoresMax"].setValue(
                previousCores
              );
              this.aimlJobForm.controls["aiml_numberOfCoresMin"].setValue(
                previousCores
              );
            }
            //this.minimumCores = null;
            //this.maximumCores = null;
          }

          // App Node Group optimization
          this.groups = appNodeGroup?.split(",") || ["Default"];
          if (!this.data.isResubmit) {
            if (
              !this.groups.includes(
                this.aimlJobForm.controls["aiml_NodeGroup"].value
              )
            ) {
              let nodeGroupsToSet;

              if (!defaultNodeGroups || defaultNodeGroups === "") {
                const defaultGroup = this.groups.find(
                  (group) => group === "Default"
                );
                if (defaultGroup) {
                  nodeGroupsToSet = [defaultGroup];
                } else {
                  // If "Default" is not found, don't set anything (leave empty)
                  nodeGroupsToSet = [];
                }
              } else {
                const firstDefaultGroup = defaultNodeGroups
                  .split(",")[0]
                  .trim();
                nodeGroupsToSet = [firstDefaultGroup];
              }

              this.aimlJobForm.controls["aiml_NodeGroup"].setValue(
                nodeGroupsToSet
              );
            }
          }

          // Memory Per CPU optimization
          this.aimlJobForm.controls["aiml_memoryPerCpu"].setValue(
            memoryPerCpu || 0
          );
        },
      });
  }

  getSetAppVersionNodeGroup() {
    this.applicationService
      .getApplicationVersions(this.depName, this.appName)
      .subscribe((data) => {
        let apps = <Application[]>JSON.parse(JSON.stringify(data));
        let self = this;

        apps.forEach(function (app) {
          let applicationVersion = new ApplicationVersion(
            app.appVersionText,
            app.appVersionValue
          );
          self.versions.push(applicationVersion);
        });
        if (!this.data.isResubmit) {
          this.aimlJobForm.controls["aiml_versionControl"].setValue(
            self.versions[0]
          );
        } else {
          let autoFillData: AppParams = JSON.parse(this.jobDetails.appPropJson);
          let appVerIdx = self.versions.findIndex(
            (a) => a.value == autoFillData.JobGenericProperties.AppVersion
          );
          if (appVerIdx != -1) {
            this.aimlJobForm.controls["aiml_versionControl"].setValue(
              self.versions[appVerIdx]
            );
          } else {
            this.aimlJobForm.controls["aiml_versionControl"].setValue(
              self.versions[0]
            );
          }
        }
        this.getApplicationStaticCores(
          this.aimlJobForm.value.aiml_versionControl.value
        );
      });
  }

  assignFixedCores(cores?: number[]) {
    this.useFixedNoOfCores = true;
    this.staticCores = cores;
    if (this.data.isResubmit) return;
    if (
      this.staticCores.includes(
        this.aimlJobForm.controls["aiml_numberOfCoresMax"].value
      )
    ) {
      return;
    }
    this.aimlJobForm.controls["aiml_numberOfCoresMax"].setValue(
      this.staticCores[0]
    );
    this.aimlJobForm.controls["aiml_numberOfCoresMin"].setValue(
      this.staticCores[0]
    );
    this.minimumCores = this.staticCores[0];
    this.maximumCores = this.staticCores[0];
  }

  private arrangeJobNameSuggestions() {
    this.filteredOptions = this.aimlJobForm
      .get("aiml_jobNamePrefix")
      .valueChanges.pipe(
        startWith(""),
        map((val) => this._filter(val, "jobName"))
      );
  }

  private arrangeTagSuggestions() {
    this.filteredTagOptions = this.aimlJobForm
      .get("aiml_Tag")
      .valueChanges.pipe(
        startWith(""),
        map((val) => this._filter(val, "tag"))
      );
  }

  private _filter(value: string, type: string): string[] {
    const filterValue = value.toLowerCase();
    const suggestions = type == "tag" ? this.tagSuggestions : this.suggestions;
    return suggestions.filter((option: any) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  isHeadNodeLinux: boolean = false;
  checkNodeData() {
    this.nodeService.getNodesForDeployment(this.depName).subscribe((data) => {
      if (!data) return;
      let nodesData = <Node[]>JSON.parse(JSON.stringify(data));
      let headNode = nodesData.find((node) => node.nodeType.includes("Head"));
      if (headNode) {
        if (
          headNode.state != HpcVMStates.STATE_CODE_STARTED &&
          !this.submitJobWithoutHN
        ) {
          this.snackBar.open(
            "Headnode is not active, job cannot be submitted.",
            "Ok"
          );
          this.isHeadnodeActive = false;
        } else {
          this.isHeadnodeActive = true;
        }

        if (headNode.vmPlatform == PlatformTypes.Linux) {
          this.isHeadNodeLinux = true;
        }

        this.maximumCoresAllowed = nodesData
          .filter((el) => el.nodeType.toLowerCase().includes("compute"))
          .map((el) => el.cores)
          .reduce((total, curr) => total + +curr, 0);

        this.aimlJobForm
          .get("aiml_numberOfCoresMax")
          .setValidators([
            Validators.max(this.maximumCoresAllowed),
            this.aimlJobForm.get("aiml_numberOfCoresMax").validator,
          ]);
        this.aimlJobForm.get("aiml_numberOfCoresMax").updateValueAndValidity();
      }
      this.loadUserDetails();
    });
  }

  loadUserDetails() {
    this.userService
      .getUserJobDirectoryPath(this.loggedInUser, this.depName)
      .subscribe({
        next: (data) => {
          this.userJobPathData = <UserJobPathData>(
            JSON.parse(JSON.stringify(data))
          );
          if (this.userJobPathData.deploymentData.jobValue == 3) {
            this.aimlJobForm.get("customWorkDirectoryPath").enable();
          }
        },
        error: (err) => {},
      });
    this.userService
      .getAllocatedCoreQuota(this.currentLoggedInUser, this.depName)
      .subscribe({
        next: (data: any) => {
          if (!data) return;
          if (data != null) {
            let coreQuota = data.allocatedCoreQuota;

            if (coreQuota == -1) {
              //do nothing, check for compute node cores
            } else {
              if (coreQuota <= this.maximumCoresAllowed) {
                this.maximumCoresAllowed = coreQuota;
                this.maximumCoresAllowed =
                  this.maximumCoresAllowed - this.data.alreadyAllocatedCores;
              } else {
                this.maximumCoresAllowed =
                  this.maximumCoresAllowed - this.data.alreadyAllocatedCores;
              }
              this.aimlJobForm
                .get("aiml_numberOfCoresMax")
                .setValidators([
                  Validators.max(this.maximumCoresAllowed),
                  this.aimlJobForm.get("aiml_numberOfCoresMax").validator,
                ]);
              this.aimlJobForm
                .get("aiml_numberOfCoresMax")
                .updateValueAndValidity();
            }
          }
        },
        error: (err) => {},
      });
  }

  setAppVersion(name) {
    let idx;
    let applicationVersion = new ApplicationVersion(name, name);
    this.versions.findIndex((ver) => {
      if (ver.name == applicationVersion.name) {
        idx = this.versions.findIndex(
          (x) => x.name === applicationVersion.name
        );
      }
    });
    this.aimlJobForm.controls["aiml_versionControl"].setValue(
      this.versions[idx]
    );
  }

  setMinMaxCores(max, min) {
    if (this.useFixedNoOfCores) {
      let idx;
      this.staticCores.findIndex((core) => {
        if (core == max) {
          idx = this.staticCores.findIndex((x) => x === max.toString());
        }
      });
      this.aimlJobForm.controls["aiml_numberOfCoresMax"].setValue(
        this.staticCores[idx]
      );
      this.aimlJobForm.controls["aiml_numberOfCoresMin"].setValue(
        this.staticCores[idx]
      );
    } else {
      this.aimlJobForm.controls["aiml_numberOfCoresMax"].setValue(max);
      this.aimlJobForm.controls["aiml_numberOfCoresMin"].setValue(min);
    }
  }

  setAdditionalInputFiles(name) {
    if (name != "") {
      let idx;
      this.splitFiles = name.split(",");
      let alreadyAdded: string[] = [];

      this.filesToCopy = this.filesToCopy.map((x) => x.split("/").slice(-1)[0]);

      this.splitFiles.forEach((x) => {
        let length = x.split("/").length;
        let fileName = x.split("/")[length - 1];
        if (this.filesToCopy.includes(fileName)) {
          idx = this.splitFiles.findIndex((file) => file == x);
          alreadyAdded.push(x);
        }
      });
      this.filesToCopy = this.splitFiles;
      this.splitFiles = this.splitFiles.filter(
        (val) => !alreadyAdded.includes(val)
      );
      this.splitFiles.forEach((file) => {
        let length = file.split("/").length;
        let fileName = file.split("/")[length - 1];
        let storageDataType = new StorageDataType(fileName, "file", file);
        let idx = this.jobAdditionalInputFiles.findIndex(
          (a) => a.name == storageDataType.name
        );
        if (idx == -1) {
          this.jobAdditionalInputFiles.push(storageDataType);
        }
      });
    }
  }

  ngOnDestroy() {
    Object.values(this.cancelledFiles).forEach((file: Subject<null>) => {
      file.next(void 0);
      file.complete();
    });
    if (this.aimlUploadSub) this.aimlUploadSub.unsubscribe();
    if (this.snackBar) this.snackBar.dismiss();
    if (this.azureTransferSub) this.azureTransferSub.unsubscribe();
    this.uploader.cancelAll();
    this.snackBar.dismiss();
    this.snackBar.dismiss();
  }

  showError(form) {
    this.aimlJobForm.markAllAsTouched();
    this.snackBar.open("Please fill / Verify all the required fields !", "Ok");
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  async checkForZipFile(fileName?) {
    const dialogRef = this.dialog.open(ManageZipDialogComponent, {
      width: "400px",
      disableClose: true,
      hasBackdrop: false,
      data: {
        fileName: fileName,
      },
    });
    return await lastValueFrom(dialogRef.afterClosed());
  }

  removeItem(obj) {
    this.filesToCopy = this.filesToCopy.filter(
      (
        (i) => (v) =>
          v !== obj.path || --i
      )(1)
    );
    this.jobAdditionalInputFiles = this.jobAdditionalInputFiles.filter(
      (
        (i) => (v) =>
          v !== obj || --i
      )(1)
    );
    if (this.cloudType == CloudTypes.OnPremise) {
      let idx = this.uploader.queue.map((i) => i.file.name).indexOf(obj.name);
      if (idx != -1) this.uploader.queue[idx].cancel();
    } else {
      if (this.cancelledFiles[obj.name]) {
        this.cancelledFiles[obj.name].next();
        this.cancelledFiles[obj.name].complete();
      }
      this.storageDataTransferService.cancelAzureUpload(obj.name);
    }
    this.checkIfUploadIsActive();
  }

  removeFile(id) {
    let currentFileName = this.aimlJobForm.controls[id].value;
    this.aimlJobForm.controls[id].setValue(null);
    this.jobInputIds[id] = null;
    if (this.cloudType == CloudTypes.OnPremise) {
      let idx = this.uploader.queue
        .map((i) => i.file.name)
        .indexOf(currentFileName);
      if (idx != -1) this.uploader.queue[idx].cancel();
    } else {
      if (this.cancelledFiles[id]) {
        this.cancelledFiles[id].next();
        this.cancelledFiles[id].complete();
      }
      this.storageDataTransferService.cancelAzureUpload(currentFileName);
    }

    let idx = this.filesToCopy.findIndex(
      (x) =>
        x.includes(currentFileName) || x.includes(currentFileName + ":Zipped")
    );
    if (idx != -1) this.filesToCopy.splice(idx, 1);
    let idx1 = this.jobInputFiles.findIndex(
      (x) =>
        x.fileName == currentFileName ||
        x.fileName == currentFileName + ":Zipped"
    );
    if (idx1 != -1) this.jobInputFiles.splice(idx1, 1);
    this.aimlJobForm.controls[id].setValue(null);
    this.storageDataTransferService.cancelAzureUpload(currentFileName);
    this.checkIfUploadIsActive();
  }

  async selectFiles(event, id?: string, toLoadSync?: boolean) {
    if (!toLoadSync) {
      //Upload
      this.isUploadActive = true;
      this.selectedFiles = event;
      const files = Array.from(event);
      if (!id) {
        files.forEach(async (file: File) => {
          if (file.name.match(this.regexObj)) {
            let user = this.authenticationService.currentUserValue.username;
            let dirPath =
              this.env.envVariables.jobFilesUploadPath +
              this.env.envVariables.slashType +
              user;
            let filePath =
              dirPath + this.env.envVariables.slashType + file.name;
            let perc: string = "Starting";
            let storageDataType = new StorageDataType(
              file.name,
              "file",
              filePath,
              perc
            );
            this.jobAdditionalInputFiles.push(storageDataType);
            let length = this.jobAdditionalInputFiles.length - 1;

            let logMsg = `${this.appName}: Uploading ${file.name} at path '${dirPath}': `;
            if (
              this.cloudType != CloudTypes.OnPremise &&
              dirPath !=
                (this.env.envVariables.syncStoreRoute ||
                  this.env.envVariables.workStoreRoute)
            ) {
              if (logMsg.indexOf(this.env.envVariables.syncStoreRoute) == -1) {
                logMsg = `${this.appName}: Uploading ${file.name} at path "${this.env.envVariables.syncStoreRoute}/${dirPath}" : `;
              }
            }
            this.actionLogService.addActionLog(
              this.depName,
              "Upload",
              file.name,
              this.currentStorageName,
              "Job",
              logMsg
            );

            this.cancelledFiles[file.name] = new Subject();

            this.uniqueAzureProgressId = this.uniqueAzureProgressId + 1;
            let toZip: boolean = false;
            if (file.name.includes(".zip")) {
              toZip = await this.checkForZipFile(file.name);
            }
            if (this.cloudType == CloudTypes.MicrosoftAzure) {
              let index = this.jobAdditionalInputFiles
                .map((p) => p.name)
                .lastIndexOf(file.name);
              if (this.checkIfStorageIsBlobForAzure()) {
                this.storageDataTransferService
                  .azureBlobJobsUploadFile(
                    dirPath,
                    file,
                    this.uniqueAzureProgressId
                  )
                  .then(
                    (data) => {
                      this.filesToCopy.push(
                        toZip ? `${filePath}:Zipped` : filePath
                      );
                      this.checkIfUploadIsActive();
                    },
                    (error) => {
                      this.jobAdditionalInputFiles[index].value = "Failed";
                      this.checkIfUploadIsActive();
                    }
                  );
              } else {
                this.storageDataTransferService
                  .azureJobsUploadFile(
                    dirPath,
                    file,
                    this.uniqueAzureProgressId
                  )
                  .then(
                    (data) => {
                      this.filesToCopy.push(
                        toZip ? `${filePath}:Zipped` : filePath
                      );
                      this.checkIfUploadIsActive();
                    },
                    (error) => {
                      this.jobAdditionalInputFiles[index].value = "Failed";
                      this.checkIfUploadIsActive();
                    }
                  );
              }
            } else if (this.cloudType == CloudTypes.OnPremise) {
              this.aimlUploadSub = this.storageService
                .JobUploadFile(this.depName, dirPath, file, this.data.nodeName)
                .pipe(
                  filter((file) => !!file),
                  takeUntil(this.cancelledFiles[file.name])
                )
                .subscribe(
                  (event: any) => {
                    if (event.type === HttpEventType.UploadProgress) {
                      if (this.jobAdditionalInputFiles[length] == undefined) {
                        length = this.jobAdditionalInputFiles.length - 1;
                      }
                      this.jobAdditionalInputFiles[length].value = Math.round(
                        (100 * event.loaded) / event.total
                      ).toString();
                    } else if (event instanceof HttpResponse) {
                      this.filesToCopy.push(
                        toZip ? `${filePath}:Zipped` : filePath
                      );
                      this.checkIfUploadIsActive();
                      this.jobAdditionalInputFiles[length].isUploadCompleted =
                        true;
                    }
                  },
                  () => {
                    this.jobAdditionalInputFiles[length].value = "Failed";
                    this.checkIfUploadIsActive();
                    this.jobAdditionalInputFiles[length].isUploadCompleted =
                      true;
                  }
                );
            } else if (this.cloudType == CloudTypes.Oracle) {
              this._oracleService
                .uploadObject(filePath, file, this.currentStorageName)
                .pipe(
                  filter((file) => !!file),
                  takeUntil(this.cancelledFiles[file.name])
                )
                .subscribe({
                  next: (event: any) => {
                    if (event.type === HttpEventType.UploadProgress) {
                      if (this.jobAdditionalInputFiles[length] == undefined) {
                        length = this.jobAdditionalInputFiles.length - 1;
                      }
                      this.jobAdditionalInputFiles[length].value = Math.round(
                        (100 * event.loaded) / event.total
                      ).toString();
                    } else if (event instanceof HttpResponse) {
                      this.filesToCopy.push(
                        this._oracleService.arrangeDirPath(
                          toZip ? `${filePath}:Zipped` : filePath
                        )
                      );
                      this.checkIfUploadIsActive();
                      this.jobAdditionalInputFiles[length].isUploadCompleted =
                        true;
                    }
                  },
                  error: (err) => {
                    this.jobAdditionalInputFiles[length].value = "Failed";
                    this.checkIfUploadIsActive();
                    this.jobAdditionalInputFiles[length].isUploadCompleted =
                      true;
                  },
                });
            } else if (this.cloudType == CloudTypes.Google) {
              var url;
              this.googleCloudService
                .uploadFilePresignedUrl(
                  this.depName,
                  this.currentStorageName,
                  filePath
                )
                .subscribe({
                  next: (data) => {
                    url = data;
                    this.googleCloudService.uploadObject(url, file).subscribe({
                      next: (event: any) => {
                        if (event.type === HttpEventType.UploadProgress) {
                          if (
                            this.jobAdditionalInputFiles[length] == undefined
                          ) {
                            length = this.jobAdditionalInputFiles.length - 1;
                          }
                          this.jobAdditionalInputFiles[length].value =
                            Math.round(
                              (100 * event.loaded) / event.total
                            ).toString();
                        } else if (event instanceof HttpResponse) {
                          this.filesToCopy.push(
                            this.googleCloudService.arrangeDirPath(
                              toZip ? `${filePath}:Zipped` : filePath
                            )
                          );
                          this.checkIfUploadIsActive();
                          this.jobAdditionalInputFiles[
                            length
                          ].isUploadCompleted = true;
                        }
                      },
                      error: (err) => {
                        this.jobAdditionalInputFiles[length].value = "Failed";
                        this.checkIfUploadIsActive();
                        this.jobAdditionalInputFiles[length].isUploadCompleted =
                          true;
                        this.actionLogService.addActionLog(
                          this.depName,
                          "Upload",
                          file.name,
                          this.currentStorageName,
                          "Job",
                          logMsg,
                          1
                        );
                      },
                    });
                  },
                });
            }
          } else {
            this.snackBar.open(
              "File with special character and space cannot be uploaded.",
              "Ok",
              {
                duration: 5000,
              }
            );
            this.checkIfUploadIsActive();
          }
        });
      } else {
        let myFile = this.selectedFiles[0];
        if (myFile.name.match(this.regexObj)) {
          let toZip: boolean = false;
          if (myFile.name.includes(".zip")) {
            toZip = await this.checkForZipFile(myFile.name);
          }
          let user = this.authenticationService.currentUserValue.username;
          let dirPath =
            this.env.envVariables.jobFilesUploadPath +
            this.env.envVariables.slashType +
            user;
          let filePath =
            dirPath + this.env.envVariables.slashType + myFile.name;

          this.jobInputIds[id] = "Starting";
          let storageDataType = new JobUploadFieldType(
            myFile.name,
            filePath,
            id,
            this.jobInputIds[id]
          );

          this.jobInputFiles.push(storageDataType);
          this.cancelledFiles[id] = new Subject();

          this.uniqueAzureProgressId = this.uniqueAzureProgressId + 1;
          if (this.cloudType == CloudTypes.MicrosoftAzure) {
            if (this.checkIfStorageIsBlobForAzure()) {
              this.storageDataTransferService
                .azureBlobJobsUploadFile(
                  dirPath,
                  myFile,
                  this.uniqueAzureProgressId,
                  id
                )
                .then(
                  (data) => {
                    this.filesToCopy.push(
                      toZip ? `${filePath}:Zipped` : filePath
                    );
                    this.checkIfUploadIsActive();
                  },
                  (error) => {
                    this.jobInputIds[id] = "Failed";
                    this.aimlJobForm.controls[id].setErrors({
                      uploadFailed: true,
                    });
                    this.checkIfUploadIsActive();
                  }
                );
            } else {
              this.storageDataTransferService
                .azureJobsUploadFile(
                  dirPath,
                  myFile,
                  this.uniqueAzureProgressId,
                  id
                )
                .then(
                  (data) => {
                    this.filesToCopy.push(
                      toZip ? `${filePath}:Zipped` : filePath
                    );
                    this.checkIfUploadIsActive();
                  },
                  (error) => {
                    this.jobInputIds[id] = "Failed";
                    this.aimlJobForm.controls[id].setErrors({
                      uploadFailed: true,
                    });
                    this.checkIfUploadIsActive();
                  }
                );
            }
          } else if (this.cloudType == CloudTypes.OnPremise) {
            this.aimlUploadSub = this.storageService
              .JobUploadFile(this.depName, dirPath, myFile, this.data.nodeName)
              .pipe(
                filter((file) => !!file),
                takeUntil(this.cancelledFiles[id])
              )
              .subscribe(
                (event: any) => {
                  if (event.type === HttpEventType.UploadProgress) {
                    this.jobInputIds[id] = Math.round(
                      (100 * event.loaded) / event.total
                    ).toString();
                  } else if (event instanceof HttpResponse) {
                    this.filesToCopy.push(
                      toZip ? `${filePath}:Zipped` : filePath
                    );
                    this.checkIfUploadIsActive();
                  }
                },
                (error) => {
                  this.jobInputIds[id] = "Failed";
                  this.aimlJobForm.controls[id].setErrors({
                    uploadFailed: true,
                  });
                  this.checkIfUploadIsActive();
                }
              );
          } else if (this.cloudType == CloudTypes.Oracle) {
            this._oracleService
              .uploadObject(filePath, myFile, this.currentStorageName)
              .pipe(
                filter((file) => !!file),
                takeUntil(this.cancelledFiles[id])
              )
              .subscribe({
                next: (event: any) => {
                  if (event.type === HttpEventType.UploadProgress) {
                    this.jobInputIds[id] = `Uploaded : ${Math.round(
                      (100 * event.loaded) / event.total
                    ).toString()} %`;
                  } else if (event instanceof HttpResponse) {
                    this.filesToCopy.push(
                      this._oracleService.arrangeDirPath(filePath)
                    );
                    this.jobInputIds[id] = "Upload Completed";
                    this.checkIfUploadIsActive();
                  }
                },
                error: (err) => {
                  this.jobInputIds[id] = "Failed";
                  this.checkIfUploadIsActive();
                },
              });
          } else if (this.cloudType == CloudTypes.Google) {
            var url;
            this.googleCloudService
              .uploadFilePresignedUrl(
                this.depName,
                this.currentStorageName,
                filePath
              )
              .pipe(
                filter((file) => !!file),
                takeUntil(this.cancelledFiles[id])
              )
              .subscribe({
                next: (data) => {
                  url = data;
                  this.googleCloudService.uploadObject(url, myFile).subscribe({
                    next: (event: any) => {
                      if (event.type === HttpEventType.UploadProgress) {
                        this.jobInputIds[id] = `Uploaded : ${Math.round(
                          (100 * event.loaded) / event.total
                        ).toString()} %`;
                      } else if (event instanceof HttpResponse) {
                        this.filesToCopy.push(
                          this.googleCloudService.arrangeDirPath(filePath)
                        );
                        this.jobInputIds[id] = "Upload Completed";
                        this.checkIfUploadIsActive();
                      }
                    },
                    error: (err) => {
                      this.jobInputIds[id] = "Failed";
                      this.checkIfUploadIsActive();
                      this.actionLogService.addActionLog(
                        this.depName,
                        "Upload",
                        myFile.name,
                        this.currentStorageName,
                        "Storage",
                        `${this.appName}: Uploading ${myFile.name} at path '${dirPath}`,
                        1
                      );
                    },
                  });
                },
              });
          }
          this.aimlJobForm.controls[id].setValue(myFile.name);
        } else {
          this.snackBar.open(
            "File with special character and space cannot be uploaded.",
            "Ok",
            {
              duration: 5000,
            }
          );
          this.checkIfUploadIsActive();
        }
      }
    } else {
      //Use Syncstore
      for (let i = 0; i < event.length; i++) {
        let myFileValue = event[i];
        var items: string[] = myFileValue.split("/");
        let myFileText = items[items.length - 1];
        let toZip: boolean = false;
        if (myFileText?.includes(".zip")) {
          toZip = await this.checkForZipFile(myFileText);
        }
        if (myFileText.replace(":Zipped", "").match(this.regexObj)) {
          if (!id) {
            let type = myFileText.includes(".") ? "file" : "folder";
            let storageDataType = new StorageDataType(
              myFileText,
              type,
              toZip ? `${myFileValue}:Zipped` : myFileValue,
              null,
              null,
              null,
              null,
              true
            );
            if (this.jobAdditionalInputFiles) {
              if (
                this.jobAdditionalInputFiles?.some(
                  (fi) => fi.name == myFileText && fi.path == myFileValue
                )
              ) {
                const toOverwrite = await lastValueFrom(
                  this.dialog
                    .open(FileAlreadyExistsActionComponent, {
                      autoFocus: false,
                      disableClose: true,
                      width: "400px",
                      data: {
                        title: "File/Folder already exists",
                        message:
                          "File/Folder with name " +
                          myFileText +
                          " already selected.",
                      },
                    })
                    .afterClosed()
                );
              } else {
                this.jobAdditionalInputFiles.push(storageDataType);
              }
            } else {
              this.jobAdditionalInputFiles.push(storageDataType);
            }
          } else {
            if (event.length < 2) {
              this.aimlJobForm.controls[id].setValue(
                myFileText.replace("Zipped", "")
              );
            } else {
              alert("Can't Select multiple files. Please select one.");
              return false;
            }
          }
          this.filesToCopy.push(toZip ? `${myFileValue}:Zipped` : myFileValue);
        } else {
          this.snackBar.open(
            "File with special character and space cannot be uploaded",
            "Ok",
            {
              duration: 5000,
            }
          );
        }
        this.checkIfUploadIsActive();
      }
    }
  }

  configureNg2FileUpload() {
    if (this.cloudType != CloudTypes.OnPremise) return;
    this.uploader.onProgressItem = (item: any) => {
      let idx = this.jobAdditionalInputFiles
        .map((i) => i.name)
        .indexOf(item.file.name);
      if (idx == -1) {
        if (this.jobInputIds[item.alias]) {
          this.jobInputIds[item.alias] = String(item["progress"]);
        }
        return;
      }
      this.jobAdditionalInputFiles[idx].value = String(item["progress"]);
    };

    this.uploader.onSuccessItem = (item: any) => {
      let idx = this.jobAdditionalInputFiles
        .map((i) => i.name)
        .indexOf(item.file.name);
      this.checkIfUploadIsActive();
      if (idx == -1) {
        idx = this.jobInputFiles.map((i) => i.fileName).indexOf(item.file.name);
        this.filesToCopy.push(this.jobInputFiles[idx].filePath);
        return;
      }
      this.jobAdditionalInputFiles[idx].isUploadCompleted = true;
      this.filesToCopy.push(this.jobAdditionalInputFiles[idx].path);
    };

    this.uploader.onErrorItem = (item: any) => {
      let idx = this.jobAdditionalInputFiles
        .map((i) => i.name)
        .indexOf(item.file.name);
      if (idx == -1) {
        if (this.jobInputIds[item.alias]) {
          this.jobInputIds[item.alias] = String(item["progress"]);
        }
        return;
      }
      this.jobAdditionalInputFiles[idx].value.ui_progress = "Failed";
    };

    this.uploader.onCompleteAll = () => {
      if (this.autoSubmitAfterUpload && !this.isUploadActive) {
        this.snackBar
          .open(
            "All files uploaded successfully. Submitting job in 5 seconds",
            "Cancel Submit",
            {
              duration: 5000,
            }
          )
          .afterDismissed()
          .subscribe((data) => {
            if (!data.dismissedByAction) {
              this.onSubmit(this.aimlJobForm);
            } else {
              this.autoSubmitAfterUpload = false;
            }
          });
      }
    };
  }

  async startNg2Upload(e, id?) {
    if (this.cloudType != CloudTypes.OnPremise) {
      this.selectFiles(e, id);
      return;
    }
    let overWriteAll: boolean = false;
    let abortAll: boolean = false;
    const event: any = Array.from(e);
    for (let index = 0; index < Array.from(event).length; index++) {
      this.isUploadActive = true;
      let idx = this.uploader.queue
        .map((i) => i.file.name)
        .lastIndexOf(event[index].name);
      let item = this.uploader.queue[idx];
      item.withCredentials = false;

      if (item.file.name.match(this.regexObj)) {
        let user = this.authenticationService.currentUserValue.username;
        let dirPath =
          this.env.envVariables.jobFilesUploadPath +
          this.env.envVariables.slashType +
          user;
        let filePath =
          dirPath + this.env.envVariables.slashType + item.file.name;
        let toZip: boolean = false;
        if (item.file.name.includes(".zip")) {
          toZip = await this.checkForZipFile(item.file.name);
        }
        if (!overWriteAll) {
          const fileExists = await lastValueFrom(
            this.storageService.checkIfFileFolderExists(
              `${filePath}`,
              "",
              this.data.headNodeIp
            )
          );
          if (fileExists) {
            if (abortAll) {
              continue;
            }
            const result = await lastValueFrom(
              this.dialog
                .open(FileAlreadyExistsActionComponent, {
                  autoFocus: false,
                  disableClose: true,
                  width: "40vw",
                  data: {
                    title: "File/Folder already exists",
                    message:
                      "File/Folder with name " +
                      item.file.name +
                      " at path " +
                      dirPath +
                      " already exists. Please choose an action to perform.",
                    showAllButtons: event.length != 1,
                  },
                })
                .afterClosed()
            );
            if (!result || result == 1) {
              if (result == 1) abortAll = true;
              this.isUploadActive = false;
              continue;
            } else if (result == 3) {
              overWriteAll = true;
            }
          }
        }

        if (!id) {
          let perc: string = "Starting";
          let storageDataType = new StorageDataType(
            item.file.name,
            "file",
            toZip ? `${filePath}:Zipped` : filePath,
            perc
          );
          if (this.jobAdditionalInputFiles) {
            if (
              this.jobAdditionalInputFiles?.some(
                (ipFile) => ipFile?.name == item?.file?.name
              )
            ) {
              this.jobAdditionalInputFiles =
                this.jobAdditionalInputFiles?.filter(
                  (obj) => obj?.name != item?.file?.name
                );
              this.jobAdditionalInputFiles.push(storageDataType);
            } else {
              this.jobAdditionalInputFiles.push(storageDataType);
            }
          } else {
            this.jobAdditionalInputFiles.push(storageDataType);
          }
        } else {
          item.alias = id;
          this.jobInputIds[id] = "Starting";
          let storageDataType = new JobUploadFieldType(
            item.file.name,
            toZip ? `${filePath}:Zipped` : filePath,
            id,
            this.jobInputIds[id]
          );
          this.jobInputFiles.push(storageDataType);
          let logMsg = `Uploading ${item.file.name} at path '${dirPath}': `;
          this.actionLogService.addActionLog(
            this.depName,
            "Upload",
            item.file.name,
            this.currentStorageName,
            "Job",
            logMsg
          );
          this.aimlJobForm.controls[id].setValue(event[index].name);
        }
        this.uploader.uploadItem(item);
      } else {
        this.snackBar.open(
          "File with special character and space cannot be uploaded.",
          "Ok",
          {
            duration: 5000,
          }
        );
      }
    }
  }

  checkAzureUpload() {
    this.azureTransferSub =
      this.storageDataTransferService.azureTransferData.subscribe(
        (data: AzureTransferProgress[]) => {
          data.forEach((element) => {
            if (!element.uploadFieldName) {
              let idx = this.jobAdditionalInputFiles
                .map((log) => log.name)
                .lastIndexOf(element.name);
              if (idx != -1) {
                this.jobAdditionalInputFiles[idx].value = element.uploaded;
                if (element.uploaded == " : Upload Completed") {
                  this.jobAdditionalInputFiles[idx].isUploadCompleted = true;
                  this.checkIfUploadIsActive();
                }
              }
            } else {
              let idx = this.jobInputFiles
                .map((log) => log.uploadFieldName)
                .lastIndexOf(element.uploadFieldName);
              if (idx != -1) {
                this.jobInputIds[element.uploadFieldName] = element.uploaded;
              }
              if (element.uploaded == " : Upload Completed") {
                this.checkIfUploadIsActive();
              }
            }
          });
        }
      );
  }

  loadSyncStoreFileTree(id?: string) {
    this.dialog
      .open(StoreExplorerComponent, {
        width: "50%",
        height: "70%",
        autoFocus: false,
        disableClose: true,
        data: { depName: this.depName, id: id, cloudType: this.cloudType },
      })
      .afterClosed()
      .subscribe((response) => {
        if (response) {
          if (!id) {
            this.selectFiles(response.data, null, true);
          } else {
            this.selectFiles(response.data, id, true);
          }
        }
      });
  }

  updateJobName(fileName, jobNumber?) {
    let jobName = this.aimlJobForm.controls["aiml_jobNamePrefix"].value;
    if (jobName != null && jobName != undefined && jobName != "") {
      return;
    }
    if (fileName != "" && fileName != null) {
      let idx = fileName.lastIndexOf(".");
      if (idx >= 30) {
        idx = 30;
      }
      if (idx != -1) {
        fileName = fileName.substring(0, idx);
      }

      if (this.aimlJobForm.value.aiml_jobNamePrefix == "") {
        let jobNamePrefix = fileName;
        if (jobNumber) {
          jobNamePrefix = jobNamePrefix + "_" + jobNumber + "R";
        }
        this.aimlJobForm.controls["aiml_jobNamePrefix"].setValue(jobNamePrefix);
        this.aimlJobForm.controls["aiml_jobNamePrefix"].markAsTouched();
      }
    }
  }

  checkIfUploadIsActive() {
    if (
      this.jobService.uploadValues.includes(this.jobInputIds["aiml_scriptFile"])
    ) {
      if (
        this.jobAdditionalInputFiles &&
        this.jobAdditionalInputFiles.length != 0
      ) {
        this.jobAdditionalInputFiles.forEach((x) => {
          if (this.jobService.uploadValues.includes(x.value)) {
            this.isUploadActive = false;
          } else {
            this.isUploadActive = true;
          }
        });
      } else {
        this.isUploadActive = false;
      }
    }
  }

  toogleDialog: boolean = false;
  toogleDialogMinMax() {
    this.toogleDialog = !this.toogleDialog;

    const currentElement = this.myElement.nativeElement;

    let dialogElement = currentElement.parentElement;
    while (
      dialogElement &&
      !dialogElement.classList.contains("cdk-overlay-pane")
    ) {
      dialogElement = dialogElement.parentElement;
    }

    if (!dialogElement) {
      console.error("Could not find parent overlay pane");
      return;
    }

    if (this.toogleDialog) {
      dialogElement.classList.add("minimize2");
      dialogElement.classList.remove("maximize");
    } else {
      dialogElement.classList.remove("minimize2");
      dialogElement.classList.add("maximize");

      setTimeout(() => {
        dialogElement.classList.remove("maximize");
      }, 300);
    }
  }

  openFileEditor(filePath?: string) {
    const dialogRef = this.dialog
      .open(FileEditorComponent, {
        disableClose: true,
        autoFocus: true,
        width: "70%",
        height: "80%",
        id: "editorDialog",
        panelClass: "file-editor-dialog",
        data: {
          depName: this.depName,
          cloudType: this.data.cloudType,
          filePath: filePath,
          headNodeIp: this.headNodeIpForUpload,
          routeViaSynchpc: this.data.routeViaSynchpc,
        },
        restoreFocus: false,
      })
      .afterClosed()
      .subscribe({
        next: (data) => {
          if (data) {
            if (filePath) {
              this.jobAdditionalInputFiles =
                this.jobAdditionalInputFiles.filter(
                  (file) => file.path !== filePath
                );
              this.filesToCopy = this.filesToCopy.filter(
                (item) => item !== filePath
              );
            }
            let fileItem = new FileItem(this.uploader, data, { url: "" });
            this.uploader.queue.push(fileItem);
            this.startNg2Upload([data]);
          }
        },
      });
  }

  editItem(file) {
    this.openFileEditor(file.path);
  }

  step = 0;

  setStep(index: number) {
    this.step = index;
  }

  nodeGroupSelectionChange(group) {
    if (this.aimlJobForm.controls["aiml_NodeGroup"].status != "INVALID") {
      return (
        this.aimlJobForm.get("aiml_NodeGroup")?.value?.length >= 2 &&
        !this.aimlJobForm.get("aiml_NodeGroup")?.value?.includes(group)
      );
    }
  }

  valueChanged() {
    this.aimlJobForm.controls["aiml_ScheduleTime"].setValue(null);
    this.aimlJobForm.controls["aiml_ScheduleTime"].setValue(
      new Date(
        new Date().getTime() + (330 + new Date().getTimezoneOffset()) * 60000
      )
    );
  }

  saveJobTemplate() {
    this.filesToCopy = [...new Set(this.filesToCopy)];
    let dynamicProp: JobDynamicProp[] = [];
    this.jobJson?.Controls.forEach((element) => {
      let propFormName = element.Name;
      let propName = element.Name.split("_")[1];
      let propValue = String(this.aimlJobForm.controls[propFormName].value);
      dynamicProp.push({
        dynamicAppKey: propName,
        dynamicAppValue: propValue,
      });
    });

    var outPath = null;
    if (
      this.env.envVariables.copyOutputToInputFileDirectory &&
      this.filesToCopy.length > 0
    ) {
      outPath = this.filesToCopy[0].split("/").slice(0, -1).join("/");
    }

    var jobData: AppParams = {
      ProductToolName: "AIML",
      JobGenericProperties: {
        JobName: this.aimlJobForm.value.aiml_jobNamePrefix,
        FilesToCopy: this.filesToCopy.join(","),
        OutDirectory: this.jobService.checkJobOutputDirectory(
          this.jobOutDir,
          this.aimlJobForm.value.aiml_outputDirectory,
          outPath
        ),
        StdOutFile: this.aimlJobForm.value.aiml_standardOutputFile,
        IsAutoShut: this.aimlJobForm.value.aiml_autoShut,
        ToBackupData: this.aimlJobForm.get("aiml_BackupData").value,
        JobPriority: this.aimlJobForm.value.aiml_Priority,
        NumOfCores: parseInt(this.aimlJobForm.value.aiml_numberOfCoresMax, 10),
        ActualCores: parseInt(this.aimlJobForm.value.aiml_numberOfCoresMax, 10),
        MinCores: parseInt(this.aimlJobForm.value.aiml_numberOfCoresMin, 10),
        NodeGroup: this.aimlJobForm.value.aiml_NodeGroup?.toString(),
        CustomTag: this.aimlJobForm.value.aiml_customTag,
        AppVersion: this.aimlJobForm.value.aiml_versionControl.value,
        IsInRecurrence: false,
        RepeatJobId: "",
        TotalRepetitions: null,
        CurrentRepetition: null,
        JobIntervalInHours: null,
        DownloadToMachine: -1,
        StartCommand: this.aimlJobForm.value.aiml_startCommand,
        EndCommand: this.aimlJobForm.value.aiml_endCommand,
        KeepWorkStoreData: this.aimlJobForm.get("aiml_keepWorkStoreData").value,
        CreateTime: this.aimlJobForm.value.aiml_customDate || null,
        JobTag: this.aimlJobForm.value.aiml_Tag,
        JobDependency: `${this.aimlJobForm.value.dependecy}:${this.aimlJobForm.value.jobID}`,
        MemoryPerCpu:
          this.aimlJobForm.value.aiml_memoryPerCpu?.toString() || null,
        WallclockTime:
          this.aimlJobForm.value.aiml_wallclockTime?.toString() || null,
        MinScratchSpace:
          this.aimlJobForm.value.aiml_MinScratchSpace?.toString() || null,
        BeginTime: this.aimlJobForm.value?.aiml_ScheduleTime
          ? new Date(
              this.aimlJobForm.value?.aiml_ScheduleTime?.getTime() -
                (330 +
                  this.aimlJobForm.value?.aiml_ScheduleTime?.getTimezoneOffset()) *
                  60000
            )
              ?.toISOString()
              ?.split(".")[0]
          : null,
        JobMpi: null,
        TasksPerNode: +this.aimlJobForm.value.aiml_taskPerNode || 0,
        ExclusiveJob: +this.aimlJobForm.value.aiml_isExclusive,
        NumOfGpuForJob: this.aimlJobForm.value.aiml_NumOfGpuForJob,
        NumOfGpuPerTask: this.aimlJobForm.value.aiml_NumOfGpuPerTask,
      },
      AIMLProperties: {
        Completions: this.aimlJobForm.value.aiml_numberOfCompletions,
        BackOffLimit: this.aimlJobForm.value.aiml_backOffLimit,
        ScriptFile: this.aimlJobForm.value.aiml_scriptFile,
        ProcessDataImage: this.aimlJobForm.value.aiml_environment?.toString(),
        MinimumGpu: this.aimlJobForm.value.aiml_NumOfGpuForJob,
        MaximumGpu: this.aimlJobForm.value.aiml_NumOfGpuForJob,
      },
      CfxProperties: null,
      CommandProperties: null,
      OpenfoamProperties: null,
      HfssProperties: null,
      MechanicalProperties: null,
      LsDynaProperties: null,
      StarCCMProperties: null,
      AbaqusProperties: null,
      ConvergeProperties: null,
      RadiossProperties: null,
      OptisProperties: null,
      NanoFluidXProperties: null,
      MscNastranProperties: null,
      MscActranProperties: null,
      OptiStructProperties: null,
      IsPlottable: false,
      ParentJobName: this.data.isJobUpdatedFlag ? this.jobDetails.name : "",
      IsUpdatedJob: this.data.isJobUpdatedFlag,
      DynamicAppProperties: dynamicProp,
      JobTemplate: this.jobTemplateNameValue,
    };
    if (jobData) {
      const newJobTemplate: JobTemplate = {
        templateId: "",
        userId: "",
        deploymentId: this.depName,
        templateName: this.jobTemplateNameValue.trim(),
        application: this.data.appName,
        applicationVersion:
          this.aimlJobForm.value.aiml_versionControl.value || "",
        appSettings: JSON.stringify(jobData),
      };

      // Ensure template name is not empty
      if (this.jobTemplateNameValue.trim() === "") {
        this.snackBar.open("Template Name is required!", "Ok", {
          duration: 5000,
        });
        return;
      }

      this.jobTemplateService
        .getJobTemplateByName(
          this.jobTemplateNameValue.trim(),
          this.data.appName
        )
        .subscribe({
          next: (response: JobTemplate | null) => {
            if (response) {
              if (response.application !== this.data.appName) {
                this.jobTemplateService
                  .createJobTemplate(newJobTemplate)
                  .subscribe({
                    next: (data) => {
                      this.snackBar.open(
                        `Job template created successfully for ${this.data.appName}!`,
                        "OK",
                        {
                          duration: 5000,
                        }
                      );
                    },
                    error: (error: any) => {
                      this.snackBar.open(
                        `Error creating job template: ${error.message}`,
                        "OK",
                        {
                          duration: 5000,
                        }
                      );
                    },
                  });
              } else {
                const dialogRef = this.dialog.open(ConfirmationDialogComponent);
                dialogRef.afterClosed().subscribe((result) => {
                  if (result) {
                    const updatedJobTemplate: JobTemplate = {
                      ...response,
                      templateName: this.jobTemplateNameValue.trim(),
                      appSettings: JSON.stringify(jobData),
                    };
                    this.jobTemplateService
                      .updateJobTemplate(updatedJobTemplate)
                      .subscribe({
                        next: (data) => {
                          this.snackBar.open(
                            `Job template updated successfully!`,
                            "OK",
                            {
                              duration: 5000,
                            }
                          );
                        },
                        error: (error: any) => {
                          this.snackBar.open(
                            `Error updating job template: ${error.message}`,
                            "OK",
                            {
                              duration: 5000,
                            }
                          );
                        },
                      });
                  }
                });
              }
            } else {
              this.jobTemplateService
                .createJobTemplate(newJobTemplate)
                .subscribe({
                  next: (data) => {
                    this.snackBar.open(
                      `Job template created successfully for ${this.data.appName}!`,
                      "OK",
                      {
                        duration: 5000,
                      }
                    );
                  },
                  error: (error: any) => {
                    this.snackBar.open(
                      `Error creating job template: ${error.message}`,
                      "OK",
                      {
                        duration: 5000,
                      }
                    );
                  },
                });
            }
          },
          error: (error: any) => {
            this.snackBar.open(
              `Error fetching job template: ${error.message}`,
              "OK",
              {
                duration: 5000,
              }
            );
          },
        });
    }
  }

  clearDate() {
    this.aimlJobForm.controls["aiml_ScheduleTime"]?.setValue(null);
  }

  azureStorageType: AzureStorageType;

  checkIfStorageIsBlobForAzure() {
    if (this.cloudType == CloudTypes.MicrosoftAzure) {
      let deployment = this.deploymentService.getProfileInfoFromSubject(
        this.depName
      );
      if (!deployment) return false;
      if (!this.azureStorageType) {
        this.azureStorageType = deployment.storageType
          ? (deployment.storageType as AzureStorageType)
          : null;
      }
      if (this.azureStorageType == AzureStorageType.TxtBlobStorage) {
        return true;
      }
    }
    return false;
  }

  isOptionDisabled(opt: any): boolean {
    if (this.aimlJobForm.controls["aiml_NodeGroup"].status != "INVALID") {
      this.snackBar.open("Maximum limit reached", "OK", { duration: 1000 });
      return (
        this.aimlJobForm.controls["aiml_NodeGroup"]?.value?.length == 2 &&
        !this.aimlJobForm.controls["aiml_NodeGroup"]?.value?.find(
          (el) => el == opt
        )
      );
    }
  }

  async onSubmit(form) {
    try {
      this.isUploadActive = true;
      this.applicationService
        .getApplicationDetails(
          this.depName,
          "AIML",
          form.value.aiml_versionControl.value
        )
        .subscribe(async (data: Application) => {
          if (data.executeFile == null) {
            this.aimlJobForm.controls["aiml_versionControl"].setErrors({
              executeFileNull: true,
            });
            this.isUploadActive = false;
            this.showError(form);
          } else {
            this.aimlJobForm.controls["aiml_versionControl"].setErrors(null);
            if (this.jobInputIds["aiml_scriptFile"] == "Failed") {
              this.aimlJobForm.controls["aiml_scriptFile"].setErrors({
                uploadFailed: true,
              });
              this.aimlJobForm.controls["aiml_scriptFile"].markAsTouched();
            }
            if (form.status == "INVALID") {
              this.isUploadActive = false;
              this.showError(form);
            } else {
              this.filesToCopy = [...new Set(this.filesToCopy)];
              let dynamicProp: JobDynamicProp[] = [];
              this.jobJson?.Controls.forEach((element) => {
                let propFormName = element.Name;
                let propName = element.Name.split("_")[1];
                let propValue = String(
                  this.aimlJobForm.controls[propFormName].value
                );
                dynamicProp.push({
                  dynamicAppKey: propName,
                  dynamicAppValue: propValue,
                });
              });

              var outPath = null;
              if (
                this.env.envVariables.copyOutputToInputFileDirectory &&
                this.filesToCopy.length > 0
              ) {
                outPath = this.filesToCopy[0].split("/").slice(0, -1).join("/");
              }

              var jobData: AppParams = {
                ProductToolName: this.data.appName,
                JobGenericProperties: {
                  JobName: this.aimlJobForm.value.aiml_jobNamePrefix,
                  FilesToCopy: this.filesToCopy.join(","),
                  OutDirectory: this.jobService.checkJobOutputDirectory(
                    this.jobOutDir,
                    this.aimlJobForm.value.aiml_outputDirectory,
                    outPath
                  ),
                  CustomWorkDirectoryPath:
                    this.aimlJobForm.value.customWorkDirectoryPath,
                  StdOutFile: this.aimlJobForm.value.aiml_standardOutputFile,
                  IsAutoShut: this.aimlJobForm.value.aiml_autoShut,
                  ToBackupData: this.aimlJobForm.get("aiml_BackupData").value,
                  JobPriority: this.aimlJobForm.value.aiml_Priority,
                  NumOfCores: parseInt(
                    this.aimlJobForm.value.aiml_numberOfCoresMax,
                    10
                  ),
                  ActualCores: parseInt(
                    this.aimlJobForm.value.aiml_numberOfCoresMax,
                    10
                  ),
                  MinCores: parseInt(
                    this.aimlJobForm.value.aiml_numberOfCoresMin,
                    10
                  ),
                  NodeGroup: this.aimlJobForm.value.aiml_NodeGroup?.toString(),
                  CustomTag: this.aimlJobForm.value.aiml_customTag,
                  AppVersion: this.aimlJobForm.value.aiml_versionControl.value,
                  IsInRecurrence: false,
                  RepeatJobId: "",
                  TotalRepetitions: null,
                  CurrentRepetition: null,
                  JobIntervalInHours: null,
                  DownloadToMachine: -1,
                  StartCommand: this.aimlJobForm.value.aiml_startCommand,
                  EndCommand: this.aimlJobForm.value.aiml_endCommand,
                  KeepWorkStoreData: this.aimlJobForm.get(
                    "aiml_keepWorkStoreData"
                  ).value,
                  CreateTime: this.aimlJobForm.value.aiml_customDate || null,
                  JobTag: this.aimlJobForm.value.aiml_Tag,
                  JobDependency: `${this.aimlJobForm.value.dependecy}:${this.aimlJobForm.value.jobID}`,
                  MemoryPerCpu:
                    this.aimlJobForm.value.aiml_memoryPerCpu?.toString() ||
                    null,
                  WallclockTime:
                    this.aimlJobForm.value.aiml_wallclockTime?.toString() ||
                    null,
                  MinScratchSpace:
                    this.aimlJobForm.value.aiml_MinScratchSpace?.toString(),
                  BeginTime: form.value?.aiml_ScheduleTime
                    ? new Date(
                        form.value?.aiml_ScheduleTime?.getTime() -
                          (330 +
                            form.value?.aiml_ScheduleTime?.getTimezoneOffset()) *
                            60000
                      )
                        ?.toISOString()
                        ?.split(".")[0]
                    : null,
                  JobMpi: null,
                  TasksPerNode: +this.aimlJobForm.value.aiml_taskPerNode || 0,
                  ExclusiveJob: +this.aimlJobForm.value.aiml_isExclusive,
                  NumOfGpuForJob: this.aimlJobForm.value.aiml_NumOfGpuForJob,
                  NumOfGpuPerTask: this.aimlJobForm.value.aiml_NumOfGpuPerTask,
                },
                FluentProperties: null,
                CfxProperties: null,
                CommandProperties: {
                  CommandLine: null,
                  IsPlottable: false,
                },
                AIMLProperties: {
                  Completions: this.aimlJobForm.value.aiml_numberOfCompletions,
                  BackOffLimit: this.aimlJobForm.value.aiml_backOffLimit,
                  ScriptFile: this.aimlJobForm.value.aiml_scriptFile,
                  ProcessDataImage:
                    this.aimlJobForm.value.aiml_environment?.toString(),
                  MinimumGpu: this.aimlJobForm.value.aiml_NumOfGpuForJob,
                  MaximumGpu: this.aimlJobForm.value.aiml_NumOfGpuForJob,
                },
                OpenfoamProperties: null,
                HfssProperties: null,
                MechanicalProperties: null,
                LsDynaProperties: null,
                StarCCMProperties: null,
                AbaqusProperties: null,
                ConvergeProperties: null,
                RadiossProperties: null,
                OptisProperties: null,
                NanoFluidXProperties: null,
                MscNastranProperties: null,
                MscActranProperties: null,
                OptiStructProperties: null,
                IsPlottable: false,
                ParentJobName: this.data.isJobUpdatedFlag
                  ? this.jobDetails.name
                  : "",
                IsUpdatedJob: this.data.isJobUpdatedFlag,
                DynamicAppProperties: dynamicProp,
              };

              const isAllow = await lastValueFrom(
                this.jobService.checkUserLicenseAvailability(
                  this.depName,
                  this.appName,
                  jobData.JobGenericProperties.AppVersion,
                  jobData.JobGenericProperties.NumOfCores
                )
              );

              if (!isAllow) {
                this.snackBar.open(
                  "Licenses are not available for the job.",
                  "Ok",
                  { duration: 5000 }
                );
                this.isUploadActive = false;
                return;
              }

              if (this.data.isResubmit)
                jobData.ParentJobName = this.data.jobName;

              this.jobService.submitJob(this.depName, jobData).subscribe({
                next: (data) => {
                  this.snackBar.open(data.message, "Ok", { duration: 5000 });
                },
                error: (err) => {
                  this.snackBar.open(err.error.message, "Ok", {
                    duration: 5000,
                  });
                },
              });
              this.dialogRef.close(true);
            }
          }
        });
    } catch (e) {
      this.isUploadActive = false;
    }
  }

  getDockerHubUrl(environment: string): string {
    if (!environment) {
      return "https://hub.docker.com/";
    }
    if (environment.includes("/")) {
      return `https://hub.docker.com/r/${environment.split("/")[0]}`;
    } else {
      return `https://hub.docker.com/r/${environment![0]?.split("/")[0]}`;
    }
  }
}
